import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  employee: {},
};

const employees = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_EMPLOYEES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };

    case types.GET_EMPLOYEE_RESPONSE:
      return { ...state, employee: action.payload };
      
    case types.EDIT_EMPLOYEE_RESPONSE:
      return {
        ...state,
        list: state.list.map(employee =>
          employee.id === action.payload.id ? action.payload : employee
        ),
        employee: action.payload
      };

    case types.DELETE_EMPLOYEE_RESPONSE:
      return {
        ...state,
        list: state.list.filter(employee => employee.id !== action.payload.id)
      };

    default:
      return state;
  }
};

export default employees;
